import { render, staticRenderFns } from "./SliderDashboardItem.vue?vue&type=template&id=070c1b9c&scoped=true"
import script from "./SliderDashboardItem.vue?vue&type=script&lang=js"
export * from "./SliderDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./SliderDashboardItem.vue?vue&type=style&index=0&id=070c1b9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c1b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070c1b9c')) {
      api.createRecord('070c1b9c', component.options)
    } else {
      api.reload('070c1b9c', component.options)
    }
    module.hot.accept("./SliderDashboardItem.vue?vue&type=template&id=070c1b9c&scoped=true", function () {
      api.rerender('070c1b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/SliderDashboardItem.vue"
export default component.exports